import React from 'react';

const AnalyticsContext = React.createContext({
  trackEvents: () => undefined,
});

export default AnalyticsContext;
